const showOnGoogleMapsFunction = (coordinates: any) => {
  let url = `https://www.google.com/maps/place/${coordinates.latitude},${coordinates.longitude}`;
  window.open(url, "_blank");
};
export default showOnGoogleMapsFunction;
